import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ee5b6c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-base mb-5 p-4 px-10 bg-buttons-red rounded-lg max-w-screen-xl" }, [
    /*#__PURE__*/_createTextVNode("⚠️ This staking platform is deprecated and will not be supported from Feb 6th 2023, please stake your DeadGods on "),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-black",
      href: "https://app.degods.com/staking"
    }, "app.degods.com/staking"),
    /*#__PURE__*/_createTextVNode(" instead.")
  ])
], -1))
const _hoisted_3 = { class: "flex flex-col sm:flex-row justify-center" }
const _hoisted_4 = { class: "flex flex-col w-full sm:w-1/5 text-center p-3 sm:p-1 justify-center stats-border-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Your wallet", -1))
const _hoisted_6 = { class: "text-4xl farm-value" }
const _hoisted_7 = { class: "flex flex-col w-full sm:w-1/5 text-center p-3 sm:p-1 justify-center stats-border-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "DeadGods staked", -1))
const _hoisted_9 = { class: "text-4xl farm-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmerRewardDisplay = _resolveComponent("FarmerRewardDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.farmerAcc?.identity.toBase58().substring(0, 4) + '....' + _ctx.farmerAcc?.identity.toBase58().slice(-4)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.farmerAcc?.gemsStaked), 1)
      ]),
      _createVNode(_component_FarmerRewardDisplay, {
        key: _ctx.farmerAcc?.rewardA,
        farmReward: _ctx.farmAcc?.rewardA,
        reward: _ctx.farmerAcc?.rewardA,
        gems: _ctx.farmerAcc?.gemsStaked,
        title: "Reward"
      }, null, 8, ["farmReward", "reward", "gems"])
    ])
  ]))
}